import { StorageTable } from "@/Features";
import { Divider, styled, useTheme } from "@monolith-forensics/monolith-ui";
import { HardDriveIcon } from "lucide-react";
import { Helmet } from "react-helmet-async";

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  flex: 1 1 auto;
`;

const StyledPageHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

const StyledPageTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  width: fit-content;
  padding: 2px 4px;
  font-weight: bold;
  font-size: 1rem;
`;

export const StorageListPage: React.FC = () => {
  const theme = useTheme();

  return (
    <StyledPage>
      <Helmet title="Storage Items" />
      <StyledPageHeader>
        <StyledPageTitle>
          <HardDriveIcon color={theme.palette.primary.main} size={18} />{" "}
          <span>Storage Items</span>
        </StyledPageTitle>
      </StyledPageHeader>
      <Divider style={{ marginBottom: 10, marginTop: 5, opacity: 0.5 }} />
      {/*
        `:v2` intentionally breaks from the legacy `storage:view` key. The old
        DevExtreme page persisted a different schema under `storage:view`; the
        mfui Table reads an incompatible shape, so the bump forces a clean reset
        of saved column/filter state instead of parsing stale data.
      */}
      <StorageTable stateStoreKey="storage:view:v2" />
    </StyledPage>
  );
};
